import React, { useEffect } from 'react'
import moment from 'moment-timezone'
import BasicModal from '../../Views/modals/BasicModal/BasicModal'
import constants from '../../config/constants.json'

function isOpen()
{
	const getNow = () => moment().tz('America/Costa_Rica')
	const openTime = getNow().hour(16).minute(0)
	const closeTime = getNow().hour(23).minute(59).add(1, 'hour')

	const now = getNow()

	return now.isSameOrAfter(openTime) && now.isSameOrBefore(closeTime)
}

export const useHoursOperationsAlert = () => {
	useEffect(() => {
		if (isOpen()) {
			return
		}
		BasicModal.Show({
			title: 'We are currently closed',
			text: (
				<span style={{ textTransform: 'none', fontSize: '1rem' }}>
					<span>Come back and play during our hours of operation:</span>
					<br />
					<span style={{ display: 'block', textAlign: 'center', fontSize: '1.2rem', fontFamily: 'Rajdhani-Bold' }}>
						{constants.HOURS_OF_OPERATION}
					</span>
				</span>
			),
			confirmTitle: 'OK'
		})
	}, [])
}
